module.exports = require("@material-ui/icons/WifiOff");